import { isLY } from '@entities/country';
import { V5_CHECKMARK } from '@shared/config/constants/api-sources';
import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import { useParams } from 'react-router-dom';

const isCheckMarkPath = () => {
  const locationPath = window.location.pathname;

  return (
    locationPath.includes('/check_mark') &&
    !locationPath.includes('/check_mark_trial') &&
    !locationPath.includes('/check_mark_weekly')
  );
};

export const useCheckMarkLYCondition = () => {
  // @ts-ignore
  const { homeData } = useAtomValue(dcbAtom);
  const { country: countryFromRoute } = useParams();

  const country = homeData.country || countryFromRoute;
  const isCheckMarkLY =
    isLY(country) && (homeData.source === V5_CHECKMARK || isCheckMarkPath());

  return {
    isCheckMarkLY,
  };
};
